/**
 * 文件定位：
 * 1. 当前文件位于 cad-core/mesh/feature/factory 层；
 * 2. 负责统一管理特征结果体/预览体对象工厂；
 * 3. 该注册表用于让 MeshManager 对扩展开放、对中心分发修改关闭。
 *
 * 文件职责：
 * 1. 注册特征 mesh 对象工厂；
 * 2. 统一尝试构建专属结果体/预览体对象；
 * 3. 为组合根提供集中注册入口。
 */

import type * as THREE from 'three';
import type {
    FeatureMeshObjectBuildInput,
    FeatureMeshObjectFactory,
} from './FeatureMeshObjectFactory';

/**
 * 特征 mesh 对象工厂注册表。
 */
export class FeatureMeshObjectFactoryRegistry {
    /** 已注册工厂集合。 */
    private readonly factories: FeatureMeshObjectFactory[] = [];

    /**
     * 注册工厂。
     * @param factory 工厂实例。
     * @returns 当前注册表。
     */
    public register(factory: FeatureMeshObjectFactory): this {
        this.factories.push(factory);
        return this;
    }

    /**
     * 批量注册工厂。
     * @param factories 工厂集合。
     * @returns 当前注册表。
     */
    public registerMany(factories: FeatureMeshObjectFactory[]): this {
        factories.forEach((factory) => {
            this.register(factory);
        });
        return this;
    }

    /**
     * 尝试创建专属特征 mesh 对象。
     * @param input 构建输入。
     * @returns 命中时返回专属 mesh，否则返回 null。
     */
    public create(input: FeatureMeshObjectBuildInput): THREE.Mesh | null {
        for (const factory of this.factories) {
            const mesh = factory.create(input);
            if (mesh) {
                return mesh;
            }
        }
        return null;
    }
}
